/**
 * @fileoverview gRPC-Web generated client stub for questionnaire
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: questionnaire/questionnaire.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var source_source_pb = require('../source/source_pb.js')

var chatcontext_chatcontext_pb = require('../chatcontext/chatcontext_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.questionnaire = require('./questionnaire_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.questionnaire.QuestionnaireServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.questionnaire.QuestionnaireServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionnaire.GetQuestionnaireRequest,
 *   !proto.questionnaire.Questionnaire>}
 */
const methodDescriptor_QuestionnaireService_GetQuestionnaire = new grpc.web.MethodDescriptor(
  '/questionnaire.QuestionnaireService/GetQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.questionnaire.GetQuestionnaireRequest,
  proto.questionnaire.Questionnaire,
  /**
   * @param {!proto.questionnaire.GetQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionnaire.Questionnaire.deserializeBinary
);


/**
 * @param {!proto.questionnaire.GetQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionnaire.Questionnaire)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionnaire.Questionnaire>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionnaire.QuestionnaireServiceClient.prototype.getQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/GetQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetQuestionnaire,
      callback);
};


/**
 * @param {!proto.questionnaire.GetQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionnaire.Questionnaire>}
 *     Promise that resolves to the response
 */
proto.questionnaire.QuestionnaireServicePromiseClient.prototype.getQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/GetQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.questionnaire.GetKnowledgeBasesResponse>}
 */
const methodDescriptor_QuestionnaireService_GetKnowledgeBases = new grpc.web.MethodDescriptor(
  '/questionnaire.QuestionnaireService/GetKnowledgeBases',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.questionnaire.GetKnowledgeBasesResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionnaire.GetKnowledgeBasesResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionnaire.GetKnowledgeBasesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionnaire.GetKnowledgeBasesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionnaire.QuestionnaireServiceClient.prototype.getKnowledgeBases =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/GetKnowledgeBases',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetKnowledgeBases,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionnaire.GetKnowledgeBasesResponse>}
 *     Promise that resolves to the response
 */
proto.questionnaire.QuestionnaireServicePromiseClient.prototype.getKnowledgeBases =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/GetKnowledgeBases',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetKnowledgeBases);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionnaire.GetAnswerSourcesRequest,
 *   !proto.questionnaire.GetAnswerSourcesResponse>}
 */
const methodDescriptor_QuestionnaireService_GetAnswerSources = new grpc.web.MethodDescriptor(
  '/questionnaire.QuestionnaireService/GetAnswerSources',
  grpc.web.MethodType.UNARY,
  proto.questionnaire.GetAnswerSourcesRequest,
  proto.questionnaire.GetAnswerSourcesResponse,
  /**
   * @param {!proto.questionnaire.GetAnswerSourcesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionnaire.GetAnswerSourcesResponse.deserializeBinary
);


/**
 * @param {!proto.questionnaire.GetAnswerSourcesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionnaire.GetAnswerSourcesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionnaire.GetAnswerSourcesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionnaire.QuestionnaireServiceClient.prototype.getAnswerSources =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/GetAnswerSources',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetAnswerSources,
      callback);
};


/**
 * @param {!proto.questionnaire.GetAnswerSourcesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionnaire.GetAnswerSourcesResponse>}
 *     Promise that resolves to the response
 */
proto.questionnaire.QuestionnaireServicePromiseClient.prototype.getAnswerSources =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/GetAnswerSources',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetAnswerSources);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionnaire.UploadKnowledgeBaseRequest,
 *   !proto.questionnaire.UploadQuestionnaireResponse>}
 */
const methodDescriptor_QuestionnaireService_UploadKnowledgeBase = new grpc.web.MethodDescriptor(
  '/questionnaire.QuestionnaireService/UploadKnowledgeBase',
  grpc.web.MethodType.UNARY,
  proto.questionnaire.UploadKnowledgeBaseRequest,
  proto.questionnaire.UploadQuestionnaireResponse,
  /**
   * @param {!proto.questionnaire.UploadKnowledgeBaseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionnaire.UploadQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.questionnaire.UploadKnowledgeBaseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionnaire.UploadQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionnaire.UploadQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionnaire.QuestionnaireServiceClient.prototype.uploadKnowledgeBase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/UploadKnowledgeBase',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_UploadKnowledgeBase,
      callback);
};


/**
 * @param {!proto.questionnaire.UploadKnowledgeBaseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionnaire.UploadQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.questionnaire.QuestionnaireServicePromiseClient.prototype.uploadKnowledgeBase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/UploadKnowledgeBase',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_UploadKnowledgeBase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionnaire.DeleteQuestionnaireRequest,
 *   !proto.questionnaire.QuestionnaireIdResponse>}
 */
const methodDescriptor_QuestionnaireService_DeleteKnowledgeBase = new grpc.web.MethodDescriptor(
  '/questionnaire.QuestionnaireService/DeleteKnowledgeBase',
  grpc.web.MethodType.UNARY,
  proto.questionnaire.DeleteQuestionnaireRequest,
  proto.questionnaire.QuestionnaireIdResponse,
  /**
   * @param {!proto.questionnaire.DeleteQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionnaire.QuestionnaireIdResponse.deserializeBinary
);


/**
 * @param {!proto.questionnaire.DeleteQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionnaire.QuestionnaireIdResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionnaire.QuestionnaireIdResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionnaire.QuestionnaireServiceClient.prototype.deleteKnowledgeBase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/DeleteKnowledgeBase',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DeleteKnowledgeBase,
      callback);
};


/**
 * @param {!proto.questionnaire.DeleteQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionnaire.QuestionnaireIdResponse>}
 *     Promise that resolves to the response
 */
proto.questionnaire.QuestionnaireServicePromiseClient.prototype.deleteKnowledgeBase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/DeleteKnowledgeBase',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_DeleteKnowledgeBase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.questionnaire.GetAccountBalanceResponse>}
 */
const methodDescriptor_QuestionnaireService_GetAccountBalance = new grpc.web.MethodDescriptor(
  '/questionnaire.QuestionnaireService/GetAccountBalance',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.questionnaire.GetAccountBalanceResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionnaire.GetAccountBalanceResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionnaire.GetAccountBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionnaire.GetAccountBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionnaire.QuestionnaireServiceClient.prototype.getAccountBalance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/GetAccountBalance',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetAccountBalance,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionnaire.GetAccountBalanceResponse>}
 *     Promise that resolves to the response
 */
proto.questionnaire.QuestionnaireServicePromiseClient.prototype.getAccountBalance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionnaire.QuestionnaireService/GetAccountBalance',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetAccountBalance);
};


module.exports = proto.questionnaire;

